<div class="table-search">
  <div
    class="icon-border icon-location-14"
    [appTooltip]="'Translation.Standardsearch' | translate"
    (click)="standardSeacrhActivated()"
    [ngClass]="isStandardSearchActive ? 'icon-border-active' : 'icon-border'"
  ></div>

  <div
    class="icon-border"
    [appTooltip]="'Translation.Searchacrossalllocations' | translate"
    (click)="searchAcrossAllLocationsActivated()"
    [ngClass]="!isStandardSearchActive ? 'icon-border-active' : 'icon-border'"
  >
    <div class="icon-globe-16"></div>
  </div>

  <div
    class="icon-information-16 info-icon"
    [appTooltip]="isStandardSearchActive ? searchByTplss : searchByTpl"
    [tooltipMaxWidth]="188"
    [tooltipIndent]="2"
    [tooltipPosition]="'bottom'"
    [tooltipTheme]="'white'"
  ></div>
   <ng-template #searchByTplss>
    <div class="seaarch-info">
      <div class="search-info-title">{{ "Translation.Searchby" | translate }}:</div>
      <ul class="search-info-list">
        <li>{{ "Translation.Meeting_name" | translate }}</li>
        <li>{{ "Translation.Meeting_id" | translate }}</li>
        <li>{{ "Translation.Meetingspecialist" | translate }}</li>
        <li>{{ "Translation.Pointofcontact" | translate }}</li>
      </ul>
    </div>
  </ng-template>
  <ng-template #searchByTpl>
    <div class="seaarch-info">
      {{ "Translation.Searchacrossalllocationstooltip" | translate }}
    </div>
  </ng-template>
  <div class="table-search__field" *ngIf="isStandardSearchActive">
    <app-search [placeholder]="placeholder | translate"
                [value]="searchValue"
                (changeValue)="onSearchValueChange($event)"
                (fieldCleared)="clearInput()"
                [onlySearch]="true"
                [isError]="false"
                [loader]="false"
                [style.flex]="'1'"></app-search>
  </div>
   <form *ngIf="form && !isStandardSearchActive" [formGroup]="form" class="table-search__field">
    <!-- Meeting name -->
      <app-search  [placeholder]="'Translation.Searchbymeetingname' | translate"
                   formControlName="meetingName"
                   [onlySearch]="true"
                   [isError]="false"
                   [loader]="false"
                   [style.flex]="'1'"
                   (fieldCleared)="clearSearchInput()"></app-search>
         <!-- Series -->   
      <app-select
        formControlName="series"
        [label]=""
        [placeholder]="'Translation.Selectseries' | translate"
        [isRequired]="false"
        [isError]="form.get('series')?.invalid"
        [errorMessage]=""
        [errorState]="'focusOut'"
      >
        <app-select-item *ngFor="let item of series"  [value]="item.id + ''" [heading]="item.name | translate"></app-select-item>
      </app-select>
  
  </form>
  <app-button
    type="button"
    class="dds-modal__footer-item"
    [kind]="'primaryLoud'"
    (clicked)="onApplyFilters()"
    [isDisabled]="!isFormApplyEnabled"
    (keyboardClicked)="onApplyFilters()"
    *ngIf="!isStandardSearchActive"
    [label]="'Translation.Apply' | translate"></app-button
  >
</div>
